import { workTaskDetailPath } from '../components/workTasks/workTaskHelpers';

// task_reopened de burada: "tamamlaman geri alindi" bildirimine tiklayan
// kisi dogrudan ilgili ise gitsin.
const TASK_NOTIFICATION_TYPES = ['task_assigned', 'task_completed', 'task_handed_off', 'task_note_added', 'task_reopened'];
const PARENT_REQUEST_NOTIFICATION_TYPES = ['parent_request_created', 'parent_request_decided'];
const MEDIA_NOTIFICATION_TYPES = ['student_video_uploaded'];

// Yarışma bildirimleri: onaylar KVKK gibi zorunlu açılır pencere olarak
// çıkmıyor — veli bildirime tıklayıp ilgili yarışmaya gidiyor ve onayı orada
// veriyor. Yönlendirmenin çalışması bu akışın tamamı için şart, bu yüzden
// hedef kaydın id'si backend'de notifications.competition_participant_id
// olarak tutuluyor.
const COMPETITION_NOTIFICATION_TYPES = [
  'competition_invitation',
  'competition_fee_approval',
  'competition_installment_due',
  'competition_document_ready',
  'competition_passport_request',
];

// Bildirime tiklaninca gidilecek sayfa - once turune (is takip/veli talebi/
// izin/medya) bakiyor, sadece o eslesmezse eskiden oldugu gibi student_id'ye
// dusuyor. Hem bell dropdown'da (MainLayout) hem "Tumunu Gor" listesinde
// (NotificationsHistoryTab) ayni davranis icin ortak kullaniliyor.
//
// role: veli ile personel farkli rotalar kullaniyor - veli /students/:id gibi
// personel sayfalarina erisemiyor, kendi /parent/* sayfalarina gitmeli.
export const notificationTarget = (n, role) => {
  const isParent = role === 'parent';

  if (COMPETITION_NOTIFICATION_TYPES.includes(n.type)) {
    // Veli doğrudan o yarışmanın detayına gider (onay orada verilir).
    // Personele bu tip bildirim gitmiyor, yine de yarışma listesine düşsün.
    if (!isParent) return '/competitions';
    return n.competition_participant_id
      ? `/parent/competitions?participant=${n.competition_participant_id}`
      : '/parent/competitions';
  }

  // İş takip: bildirimde hedef iş varsa DOĞRUDAN o işin detayına gidilir —
  // kullanıcı "X kişisi şu işe not ekledi" bildirimine tıklayınca hangi işten
  // bahsedildiğini görebilsin diye. work_task_id 05.08.2026'da eklendi; daha
  // önce gönderilmiş bildirimlerde bu alan boş, onlar eskisi gibi listeye
  // düşer (yönlendirmesiz kalmasınlar).
  if (TASK_NOTIFICATION_TYPES.includes(n.type)) {
    if (isParent) return null;
    // Rol bazli yol: stajyerin ekranlari /intern altinda. Mutlak
    // `/work-tasks/...` verilince stajyer StaffRoute'a dusup ana sayfaya
    // atiliyordu.
    return workTaskDetailPath(role, n.work_task_id);
  }
  if (PARENT_REQUEST_NOTIFICATION_TYPES.includes(n.type)) {
    return isParent ? '/parent/students?tab=requests' : '/parent-requests';
  }

  // Veli BİLGİ GÜNCELLEME isteği — yukarıdaki veli talepleriyle karıştırma,
  // ayrı bir akış. Yönetici doğrudan o velinin kullanıcı sayfasındaki
  // "İstekleri" sekmesine gider: metni orada okur, değişikliği aynı ekranda
  // yapar ve "Yapıldı" işaretler. Bildirimi okuyup ne yapacağını ayrıca
  // hatırlamak zorunda kalmasın diye tek tıkla işin yapılacağı yere gidiyor.
  if (n.type === 'parent_profile_change') {
    if (isParent) return null;
    return n.target_user_id ? `/users/${n.target_user_id}?tab=requests` : '/users';
  }

  // Yöneticinin "isteğiniz sonuçlandı" cevabı — veliyi kendi profiline
  // götürüyoruz, bilgilerinin güncellenip güncellenmediğini oradan görsün.
  if (n.type === 'parent_profile_change_done') {
    return isParent ? '/parent/profile' : null;
  }
  if (n.type === 'leave_requested') return isParent ? null : '/leave-requests';
  if (n.type === 'leave_decided') return isParent ? null : '/profile?tab=leaves';

  // Medya yuklendi - veliyi dogrudan o ogrencinin Medya sekmesine goturuyoruz.
  if (MEDIA_NOTIFICATION_TYPES.includes(n.type) && n.student_id) {
    return isParent
      ? `/parent/students?tab=media&student=${n.student_id}`
      : `/students/${n.student_id}?tab=media`;
  }

  if (n.student_id) {
    return isParent
      ? `/parent/students?student=${n.student_id}`
      : `/students/${n.student_id}?tab=certificates`;
  }
  return null;
};
